import { Effect } from "../Materials/effect";
var name = 'blackAndWhitePixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nuniform float degree;\nvoid main(void)\n{\nvec3 color=texture2D(textureSampler,vUV).rgb;\nfloat luminance=dot(color,vec3(0.3,0.59,0.11));\nvec3 blackAndWhite=vec3(luminance,luminance,luminance);\ngl_FragColor=vec4(color-((color-blackAndWhite)*degree),1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var blackAndWhitePixelShader = { name: name, shader: shader };
//# sourceMappingURL=blackAndWhite.fragment.js.map